import { cn } from '@ahm/common-helpers';
import type { ReactNode } from 'react';

interface HeaderBackgroundProps {
  children: ReactNode;
  className?: string;
}

/**
 * Ambient backdrop cho mobile homepage header.
 *
 * Hiện dùng CSS gradient + subtle pattern (fallback). Khi designer cung cấp
 * SVG decoration, swap nội dung của `<div aria-hidden>` bên dưới — props
 * giữ nguyên nên các call site không cần đổi.
 */
export function HeaderBackground({
  children,
  className,
}: HeaderBackgroundProps) {
  return (
    <div
      className={cn(
        'relative overflow-hidden overflow-x-clip bg-white',
        className
      )}
    >
      {children}
    </div>
  );
}
